export default "/images/6e20a0d7d95931429cfe74328ef6a4f5.avif";